import Phaser from 'phaser';
import { GAME_WIDTH, GAME_HEIGHT, COLORS } from '../utils/Constants';

export class MenuScene extends Phaser.Scene {
  constructor() {
    super({ key: 'MenuScene' });
  }

  create(): void {
    // Background
    this.add.rectangle(GAME_WIDTH / 2, GAME_HEIGHT / 2, GAME_WIDTH, GAME_HEIGHT, COLORS.TABLE_FELT);

    // Title
    this.add.text(GAME_WIDTH / 2, 150, 'BURACO', {
      fontSize: '72px',
      color: COLORS.TEXT_LIGHT,
      fontFamily: 'Georgia, serif',
      fontStyle: 'bold',
    }).setOrigin(0.5).setShadow(3, 3, '#000000', 5);

    // Subtitle
    this.add.text(GAME_WIDTH / 2, 220, 'Italian Card Game', {
      fontSize: '24px',
      color: '#aaaaaa',
      fontFamily: 'Georgia, serif',
      fontStyle: 'italic',
    }).setOrigin(0.5);

    // Decorative cards
    const cardPositions = [
      { x: 300, y: 400, angle: -15, key: 'card_hearts_1' },
      { x: 500, y: 380, angle: -5, key: 'card_diamonds_13' },
      { x: 700, y: 370, angle: 5, key: 'card_clubs_1' },
      { x: 900, y: 385, angle: 12, key: 'card_spades_13' },
    ];

    for (const pos of cardPositions) {
      if (this.textures.exists(pos.key)) {
        this.add.image(pos.x, pos.y, pos.key)
          .setAngle(pos.angle)
          .setScale(1.5)
          .setAlpha(0.5);
      }
    }

    // Buttons
    this.createButton(GAME_WIDTH / 2, 500, 'New Game', () => {
      this.scene.start('GameScene');
    });

    this.createButton(GAME_WIDTH / 2, 570, 'Rules', () => {
      this.scene.start('RulesScene', { returnTo: 'MenuScene' });
    });
  }

  private createButton(x: number, y: number, text: string, callback: () => void): void {
    const w = 250;
    const h = 50;

    const bg = this.add.rectangle(x, y, w, h, COLORS.BUTTON, 0.9)
      .setInteractive({ useHandCursor: true })
      .on('pointerover', () => {
        bg.setFillStyle(COLORS.BUTTON_HOVER, 1);
        label.setScale(1.05);
      })
      .on('pointerout', () => {
        bg.setFillStyle(COLORS.BUTTON, 0.9);
        label.setScale(1);
      })
      .on('pointerdown', callback);

    // Border
    this.add.rectangle(x, y, w + 2, h + 2, COLORS.UI_BORDER).setDepth(-1);

    const label = this.add.text(x, y, text, {
      fontSize: '22px',
      color: COLORS.TEXT_LIGHT,
      fontFamily: 'Georgia, serif',
    }).setOrigin(0.5);
  }
}
